import { validDate } from '@src/utils/date-utils';
import { BATCH_JOB_STATUS, BatchJobStatus, RestartMap } from './dag-status-constants';
import { DagBuildStatus } from './use-dag-status';

export const isBatchJobStatus = (status: string): status is BatchJobStatus =>
  Object.values<string>(BATCH_JOB_STATUS).includes(status);

export const isTerminalStatus = (statusBatch: string): boolean =>
  statusBatch === BATCH_JOB_STATUS.SUCCEEDED || statusBatch === BATCH_JOB_STATUS.FAILED;

export const getDagKey = ({
  batch_job_name,
  company,
  dag
}: Pick<DagBuildStatus, 'batch_job_name' | 'company' | 'dag'>): string =>
  `${batch_job_name}_${company}_${dag}`;

// Guard null before wrapping: new Date(null) is the epoch, which validDate accepts.
export const isValidDateString = (value?: string | null): boolean =>
  value != null && validDate(new Date(value));

export const omitRestart = (restarts: RestartMap, dagKey: string): RestartMap => {
  if (!(dagKey in restarts)) return restarts;
  return Object.fromEntries(Object.entries(restarts).filter(([key]) => key !== dagKey));
};

// Drops markers whose restart took effect; same reference when unchanged, to avoid re-renders.
export const pruneRestarts = (
  restarts: RestartMap,
  builds: Pick<
    DagBuildStatus,
    'batch_job_name' | 'company' | 'dag' | 'status_batch' | 'job_start_time'
  >[]
): RestartMap =>
  builds.reduce((acc, build) => {
    const dagKey = getDagKey(build);
    const marker = acc[dagKey];
    if (!marker) return acc;
    const restarted =
      !isTerminalStatus(build.status_batch) || build.job_start_time !== marker.job_start_time;
    return restarted ? omitRestart(acc, dagKey) : acc;
  }, restarts);
